export const getField = (state) => state.cropMonitoring.field;
export const getRecommendation = (state) => state.cropMonitoring.recommendation;
export const getPlantingDate = (state) => state.cropMonitoring.plantingDate;
export const getEnvironment = (state) => state.cropMonitoring.environment;
export const getHybrid = (state) => state.cropMonitoring.hybrid;
export const getFertilizer = (state) => state.cropMonitoring.fertilizer;
export const getFertilizerAmount = (state) => state.cropMonitoring.fertilizerAmount;
export const getBtnDisabled = (state) => state.cropMonitoring.btnDisabled;
export const getCropProtectionProducts = (state) => state.cropMonitoring.cropProtectionProducts;
export const getComesFromNotification = (state) => state.cropMonitoring.comesFromNotification;
